import React from "react";
import { FormattedMessage } from "react-intl";

function TableHead(props) {
  return (
    <thead className="thead-light">
    <tr>
      <th
        className="sort"
        data-sort="created_at"
        scope="col"
        onClick={ () => props.applySort( "created_at" ) }
      >
        <FormattedMessage
          id="components.pages.clients.clientsTable.table.created_at"/>
      </th>
      <th
        className="sort"
        data-sort="first_name"
        scope="col"
        onClick={ () => props.applySort( "first_name" ) }
      >
        <FormattedMessage
          id="components.pages.clients.clientsTable.table.first_name"/>
      </th>
      <th
        className="sort"
        data-sort="last_name"
        scope="col"
        onClick={ () => props.applySort( "last_name" ) }
      >
        <FormattedMessage
          id="components.pages.clients.clientsTable.table.last_name"/>
      </th>
      <th
        className="sort"
        data-sort="email"
        scope="col"
        onClick={ () => props.applySort( "email" ) }
      >
        <FormattedMessage
          id="components.pages.clients.clientsTable.table.email"/>
      </th>
      <th scope="col">
        <FormattedMessage
          id="components.pages.clients.clientsTable.table.organizations"/>
      </th>
      <th
        className="sort"
        data-sort="status"
        scope="col"
        onClick={ () => props.applySort( "status" ) }
      >
        <FormattedMessage
          id="components.pages.clients.clientsTable.table.status"/>
      </th>
      <th scope="row" className="w-10">
        <FormattedMessage
          id="components.pages.clients.clientsTable.table.actions"/>
      </th>
    </tr>
    </thead>
  );
}

export { TableHead };
